/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';

import './style.scoped.scss';
//import { Link } from 'react-router-dom';
// import { displayDocVersion } from '../../assets/constants/strings';
import { connect } from 'react-redux';
import { setCurrentDocument } from '../../store/Document/documentActions';
import { FaCaretLeft, FaCaretRight } from 'react-icons/fa';
import $ from 'jquery';
import { TranslateWorkaround } from '../../assets/constants/strings';

const TopNav = ({
  handleLevelSelected,
  // setCurrentDocument,
  levelOnes,
  isPreview,
}) => {
  // const handleSetDocument = async (id: string) => {
  //   await setCurrentDocument(id);
  // };

  useEffect(() => {
    $(window).on('resize', checkPositionings);
  }, []);

  const checkPositionings = () => {
    if (levelOnes && levelOnes.length > 0) {
      const leftCaret = document.getElementById(`left-caret`);
      const rightCaret = document.getElementById(`right-caret`);

      const firstElement = document.getElementById(`dropdown-1`);
      const lastElement = document.getElementById(`dropdown-${levelOnes.length}`);

      if (firstElement && leftCaret) {
        // to determine carets visibility, need to check if element's width plus padding is completely visible
        const clientWidth = firstElement.clientWidth;
        const distanceFromRight = firstElement.getBoundingClientRect().right;
        let topNavPadding = 48;

        try {
          topNavPadding = Number($('#topNav').css('padding-left').replace('px', ''));
        } catch (e) {
          console.log('EXC', e.message);
          topNavPadding = 48;
        }

        leftCaret.style.display = distanceFromRight < clientWidth + topNavPadding ? 'flex' : 'none';
      }

      if (lastElement && rightCaret) {
        const clientWidth = lastElement.clientWidth;
        const distanceFromLeft = lastElement.getBoundingClientRect().left;
        let topNavPadding = 48;

        try {
          topNavPadding = Number($('#topNav').css('padding-left').replace('px', ''));
        } catch (e) {
          console.log('EXC', e.message);
          topNavPadding = 48;
        }

        // to determine carets visibility, need to check if element's distance is larger than the window
        rightCaret.style.display =
          distanceFromLeft > window.innerWidth - clientWidth - topNavPadding ? 'flex' : 'none';
      }
    }
  };

  const moveList = (to) => {
    if (to === 'left') {
      // scroll to the left
      $('#nav-items-list').scrollLeft(window.innerWidth);
      document.getElementById(`right-caret`).style.display = 'none';
      document.getElementById(`left-caret`).style.display = 'flex';
    } else {
      // scroll to the right
      $('#nav-items-list').scrollLeft(0);
      document.getElementById(`left-caret`).style.display = 'none';
      document.getElementById(`right-caret`).style.display = 'flex';
    }
  };

  checkPositionings();

  return (
    <div
      className={`topNav${isPreview ? ' topNav__item-preview' : ''}`}
      id="topNav"
      onMouseEnter={checkPositionings}
    >
      <div className="topNav__arrow left" id="left-caret">
        <FaCaretLeft fontSize="2em" color="white" onClick={() => moveList('right')} />
      </div>
      <div className="topNav__list" id="nav-items-list" onScrollCapture={checkPositionings}>
        {levelOnes &&
          levelOnes.map((levelOne, index) => (
            <div
              key={index}
              className={`topNav__list__item${levelOnes.length === 1 ? ' left-align' : ''}${TranslateWorkaround(levelOne.Title)}`}
              id={`dropdown-${index + 1}`}
              onClick={!isPreview ? () => handleLevelSelected(levelOne) : null}
            >
              {levelOne.Title}
            </div>
          ))}
      </div>
      <div className="topNav__arrow right" id="right-caret">
        <FaCaretRight fontSize="2em" color="white" onClick={() => moveList('left')} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isPreview: state.client.isPreview,
  levelOnes: state.client.levelOneList,
});

const mapDispatchToProps = { setCurrentDocument };

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(TopNav);
